var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWellbeingFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2317_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9823 3.96152C27.9621 3.58896 27.6884 3.26711 27.3204 3.17893C23.2371 2.20897 20.206 2.57271 18.3124 4.26353C15.7727 6.52972 16.1159 10.4669 16.2461 11.4258C15.7233 12.2922 15.2858 13.2599 14.9381 14.3115C14.5028 12.6515 13.8881 11.1591 13.105 9.86507C13.2509 8.80693 13.6659 4.37816 10.8054 1.81657C8.68068 -0.0858779 5.27267 -0.495908 0.680038 0.595302C0.309846 0.68348 0.0383715 1.00754 0.0181792 1.38009C0.000230523 1.6799 -0.376693 8.72096 3.50023 11.3266C5.5217 12.6846 8.31722 12.5964 11.8127 11.0621C13.1252 13.39 13.8499 16.3925 13.9666 19.9924C13.9666 20.0299 13.9666 20.0673 13.9688 20.0894C13.998 21.0637 13.9823 22.0778 13.9239 23.1029C13.8993 23.5724 14.2695 23.9758 14.7473 23.9979C14.7631 23.9979 14.7765 23.9979 14.7922 23.9979C15.0076 23.9979 15.2118 23.9207 15.3733 23.7774C15.5461 23.6253 15.647 23.4159 15.6582 23.1889C15.7188 22.1021 15.7323 21.0285 15.7009 20.0166C15.8467 16.8731 16.5332 14.2718 17.738 12.2746C18.5345 13.1652 20.2733 13.4892 20.4999 13.5223C22.5191 13.8331 24.1749 13.4231 25.4201 12.2988C28.3547 9.65124 27.9845 4.01002 27.98 3.95711L27.9823 3.96152Z",
    fill: "#726FB3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2317_951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellbeingFilled);
export default __webpack_public_path__ + "static/media/wellbeing-filled.8d731ca1c45bb931d0c3f641d7a3e2d2.svg";
export { ForwardRef as ReactComponent };